import { MapUtils } from '../../utility/map-utils.js';
import {
  DataModel, DataModelBuilder, SerializationContext, SerializedData,
} from '../dto/data-model.js';

export class DesktopBridgeInfo extends DataModel {
  static readonly TYPE_ID: string = 'ee9998dc21f843e788765574ff522e4a';

  private constructor(
    public readonly currentVersion: string,
  ) {
    super();
  }

  get $typeId(): string {
    return DesktopBridgeInfo.TYPE_ID;
  }

  static create(args: { currentVersion: string }): DesktopBridgeInfo {
    return new DesktopBridgeInfo(args.currentVersion);
  }

  static fromMap(_context: SerializationContext, map: SerializedData): DesktopBridgeInfo {
    return DesktopBridgeInfo.create({
      currentVersion: MapUtils.getString(map, 'currentVersion'),
    });
  }

  toMap(_context: SerializationContext): SerializedData {
    return {
      currentVersion: this.currentVersion,
    };
  }

  clone(): this {
    return DesktopBridgeInfo.create({
      currentVersion: this.currentVersion,
    }) as this;
  }

  isSame(other: this): boolean {
    return other === this || other.currentVersion === this.currentVersion;
  }
}

export class DesktopBridgeInfoBuilder extends DataModelBuilder<DesktopBridgeInfo> {
  build(context: SerializationContext, map: SerializedData): DesktopBridgeInfo {
    return DesktopBridgeInfo.fromMap(context, map);
  }
}
